var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.548,
    height: 35.547,
    viewBox: "0 0 30.548 35.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6976",
    "data-name": "Group 6976",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16136",
    "data-name": "Path 16136",
    d: "M235.752,182.774c-.883,0-1.511.373-1.511.922v7.475c0,.471.628.942,1.511.942.844,0,1.53-.471,1.53-.942V183.7C237.282,183.147,236.6,182.774,235.752,182.774Z",
    transform: "translate(-220.478 -170.085)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16137",
    "data-name": "Path 16137",
    d: "M234.437,116.361a1.414,1.414,0,1,0,1.589,1.393A1.52,1.52,0,0,0,234.437,116.361Z",
    transform: "translate(-219.163 -108.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16138",
    "data-name": "Path 16138",
    d: "M51.274,0a15.266,15.266,0,0,0-4.623,29.818l3.474,5.12a1.389,1.389,0,0,0,2.3,0l3.474-5.12A15.266,15.266,0,0,0,51.274,0Zm3.377,27.292a1.389,1.389,0,0,0-.775.558l-2.6,3.835-2.6-3.835a1.389,1.389,0,0,0-.775-.558,12.5,12.5,0,1,1,6.755,0Z",
    transform: "translate(-36 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.a154f2d0.svg";
export { ForwardRef as ReactComponent };